import { render, staticRenderFns } from "./InvoiceBody.vue?vue&type=template&id=45f66cd0&scoped=true&"
import script from "./InvoiceBody.vue?vue&type=script&lang=js&"
export * from "./InvoiceBody.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceBody.vue?vue&type=style&index=0&id=45f66cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f66cd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Projects/Coding/Nhafatura/appfactura-spa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
